import { Link } from 'react-router-dom';
import { Card, Col, Row, Typography } from 'antd';
import { useSession } from '../../stores/session';
import { canSeeRoute } from '../../components/route-access';
import { roleLabel } from '../../utils/role-labels';
import { SalesWorkbench } from './workbench';
import { VoucherApprovalsCard } from './voucher-approvals';
import { OversightPanel } from './oversight';

const { Title, Paragraph } = Typography;

const QUICK_LINKS = [
  { to: '/advisor/customers', title: '顾问客户', desc: '建档、开单、跟进讲述' },
  { to: '/dashboard/north-star', title: '北极星看板', desc: '核心增长与转化指标' },
  { to: '/orders', title: '打印订单', desc: '订单处理与物流跟踪' },
  { to: '/users', title: '用户查询', desc: '用户详情与处置' },
  { to: '/ai-tasks', title: 'AI 任务监控', desc: '生成任务状态与重试' },
  { to: '/refunds', title: '退款审批', desc: '双人审批流程' },
  { to: '/admins', title: '管理员', desc: '账号、角色与权限' },
];

export default function HomePage() {
  const role = useSession((s) => s.role);
  return (
    <div data-testid="home-page">
      <Title level={3} style={{ marginBottom: 4 }}>
        欢迎回来，经年叙运营后台
      </Title>
      <Paragraph type="secondary">
        当前角色：{roleLabel(role)}。从左侧菜单或下方快捷入口开始。
      </Paragraph>
      <SalesWorkbench />
      <VoucherApprovalsCard />
      <OversightPanel />
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        {QUICK_LINKS.filter((l) => canSeeRoute(role, l.to)).map((l) => (
          <Col xs={24} sm={12} md={8} key={l.to}>
            <Link to={l.to}>
              <Card hoverable styles={{ body: { minHeight: 92 } }}>
                <Card.Meta title={l.title} description={l.desc} />
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}
